import type { ZodType } from "zod";
import { stringRequiredSchema } from "./stringRequired";

export type DataListType =
  "airports" | "airlines" | "streetNames" | "nationalities" | "countries";

export const autoSuggestZodDescription = "auto_suggest";

export const autoSuggestSchema =
  <T extends ZodType>(schema: T) =>
  (dataList: DataListType) =>
    schema.meta({
      description: autoSuggestZodDescription,
      type: dataList,
    });

export const autoSuggestStringRequiredSchema = (dataList: DataListType) =>
  autoSuggestSchema(stringRequiredSchema)(dataList);

export const autoSuggestStreetNames = (zipCodeFieldNamesReference: string[]) =>
  stringRequiredSchema.meta({
    description: autoSuggestZodDescription,
    type: "streetNames",
    dataListArguments: zipCodeFieldNamesReference,
  });
